import { t } from '@lingui/macro';
import * as ChartAnnotation from 'chartjs-plugin-annotation';
import Color from 'color';
import isEmpty from 'lodash/isEmpty';
import React, { memo } from 'react';
import { trans } from '../../../config/LinguiConfig';
import { successColor } from '../../../variables/color';
import CustomChart from '../components/CustomChart/CustomChart';

const getOption = () => ({
  plugins: [ChartAnnotation],
  aspectRatio: 1,
  tooltips: {
    enabled: false,
    position: 'nearest',
    mode: 'nearest',
    backgroundColor: '#f5f5f5',
    titleFontColor: '#333',
    bodyFontColor: '#666',
    bodySpacing: 4,
    xPadding: 12,
    intersect: 0,
  },
  annotation: {
    drawTime: 'beforeDatasetsDraw',
    annotations: [
      {
        type: 'line',
        mode: 'horizontal',
        scaleID: 'y-axis-0',
        value: 0,
        borderColor: '#eeeeee',
        borderWidth: 2,
        borderDash: [3, 3],
      },
    ],
  },
  legend: {
    display: false,
  },
  scales: {
    xAxes: [
      {
        scaleLabel: {
          labelString: t`Hiển thị`,
        },
        ticks: {
          suggestedMin: 0,
          beginAtZero: true,
          callback: function (value) {
            if (value % 1 === 0) {
              return value;
            }
          },
        },
      },
    ],
    yAxes: [
      {
        scaleLabel: {
          labelString: t`Tương tác`,
        },
        ticks: {
          suggestedMin: 0,
          beginAtZero: true,
          callback: function (value) {
            if (value % 1 === 0) {
              return value;
            }
          },
        },
      },
    ],
  },
});

const color = [successColor];
const normalizedData = (data) => {
  if (isEmpty(data)) return {};
  if (data?.datasets?.forEach)
    data.datasets.forEach((item, index) => {
      item.backgroundColor = Color(color[index]).alpha(0.5).string();
      item.borderColor = color[index];
    });

  return data;
};

const getColumns = () => [
  {
    Header: t`Tên`,
    accessor: 'name',
  },
  {
    Header: t`Hiển thị`,
    width: 100,
    accessor: 'x',
  },
  {
    Header: t`Tương tác`,
    width: 100,
    accessor: 'y',
  },
];

const ScenarioPerformance = (props) => {
  return (
    <CustomChart
      normalizedData={normalizedData}
      getOption={getOption}
      columns={getColumns()}
      {...props}
    />
  );
};

export default memo(ScenarioPerformance);
